import { VoucherPrintOrgHeading, VoucherPrintOrgAddress, VoucherPrintDepartmentFooter } from "./VoucherPrintOrgHeader";
import PrintCommon from "app/common/Component/Print/PrintCommon";
import {
  VOUCHER_INVOICE_TYPE,
  VOUCHER_INVOICE_TYPE_VALUE,
} from "app/common/LocalConst";
import { formatMoney, formatPrintPatientCodeSuffix, getDateTime, hideMiddleDigits } from "app/common/LocalFunction";
import React, { memo } from "react";
import QrSurveySection from "app/common/Component/Print/QrSurveySection";

const PrintFormRetailProductService = ({
  componentRef,
  rowDataVoucher,
  staffRevenues = [],
}) => {
  const namesText = Array.isArray(staffRevenues)
    ? staffRevenues?.map((item) => item?.staff?.staffName).join(" ; ")
    : "Không rõ";
  // (curr?.moneyAfterDiscount || 0),

  const totalValue =
    rowDataVoucher?.items?.length > 0 &&
    rowDataVoucher?.items?.reduce(
      (acc, curr) => {
        return {
          totalQuantity: acc.totalQuantity + (curr?.quantity || 0),
          totalPrice:
            acc.totalPrice + (curr?.price || 0) * (curr?.quantity || 0),
          totalAmount:
            acc.totalAmount + (curr?.invoiceItem?.subAmountActuallyPaid || 0),
          totalPaid:
            acc.totalPaid +
            (curr?.invoiceItem?.subTotalBillPatientPaid || 0) -
            (curr?.moneyAfterDiscount || 0),
          totalCurrentPaid: acc.totalCurrentPaid + curr?.moneyAfterDiscount,
          totalDebit:
            acc.totalDebit +
            (curr?.invoiceItem?.subAmountActuallyPaid -
              curr?.invoiceItem?.subTotalBillPatientPaid),
        };
      },
      {
        totalQuantity: 0,
        totalAmount: 0,
        totalPrice: 0,
        totalPaid: 0,
        totalCurrentPaid: 0,
        totalDebit: 0,
      }
    );

  return (
    <PrintCommon ref={componentRef} marginPage="4mm" hidden={false}>
      <header className="printHeader w-100 flex justify-between print-voucher">
        <table className="table-layout-fixed">
          <div className="wraper-print">
            <div
              className="container-print"
              style={{ maxWidth: "300px", padding: "10px 20px 10px 0px" }}
            >
              <VoucherPrintOrgHeading department={rowDataVoucher?.department} />
              <VoucherPrintOrgAddress department={rowDataVoucher?.department} />

              <div className="mt-5 text-center">
                <h4 style={{ fontWeight: "bold", fontSize: "16px" }}>
                  HÓA ĐƠN BÁN HÀNG
                </h4>
                <div className="center">
                  {getDateTime(rowDataVoucher?.voucherDate)}
                </div>
              </div>
              <table
                className="info-print"
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        width: "30%",
                        fontWeight: "bold",
                        padding: "4px 0",
                      }}
                    >
                      KH:
                    </td>
                    <td
                      style={{
                        width: "70%",
                        padding: "4px 0",
                        fontWeight: "bold",
                      }}
                    >
                      {rowDataVoucher?.patient?.displayName || ""}{" "}
                      {formatPrintPatientCodeSuffix(rowDataVoucher?.patient)}{" "}
                      {rowDataVoucher?.patient?.phoneNumber
                        ? `- ${hideMiddleDigits(rowDataVoucher?.patient?.phoneNumber)}`
                        : ""}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                      Ngày:
                    </td>
                    <td style={{ padding: "4px 0", fontWeight: "bold" }}>
                      {getDateTime(rowDataVoucher?.voucherDate)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                      Tư vấn viên:
                    </td>
                    <td style={{ padding: "4px 0", fontWeight: "bold" }}>
                      {namesText}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                      Thu ngân:
                    </td>
                    <td style={{ padding: "4px 0", fontWeight: "bold" }}>
                      {" "}
                      {rowDataVoucher?.accountant?.staffName || "Không rõ"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                      HĐ:
                    </td>
                    <td style={{ padding: "4px 0", fontWeight: "bold" }}>
                      {rowDataVoucher?.code || "Chưa có mã"}
                    </td>
                  </tr>
                </tbody>
              </table>

              <table className="table-print">
                <thead className="thead-print">
                  <tr>
                    <th width="15%">SL</th>
                    <th>Đ.Giá</th>
                    <th>KM</th>
                    <th>Thành tiền</th>
                  </tr>
                </thead>
                {console.log("rowDataVoucher", rowDataVoucher)}
                <tbody className="tbody-print">
                  {rowDataVoucher?.items?.length > 0 ? (
                    rowDataVoucher?.items?.map((it, index) => {
                      return (
                        <React.Fragment key={`srv-${it?.id}`}>
                          {/*  Tên dịch vụ */}
                          <tr className="no-border">
                            <td colSpan={4} className="service-name-td">
                              {it?.invoiceItem?.patientServiceRegister?.name ||
                                it?.invoiceItem?.drugOrder?.name ||
                                it?.invoiceItem?.treatmentPlanCard?.name ||
                                "Dịch vụ không rõ"}
                            </td>
                          </tr>
                          {/*  Thông tin chi tiết */}
                          <tr>
                            <td>
                              {it?.invoiceItem?.quantity ||
                                it?.invoiceItem?.soldQuantity ||
                                0}
                            </td>
                            <td>
                              {formatMoney(
                                it?.invoiceItem?.patientServiceRegister
                                  ?.price ||
                                it?.invoiceItem?.drugOrder?.price ||
                                it?.invoiceItem?.treatmentPlanCard?.price ||
                                0
                              )}
                            </td>
                            <td>
                              {formatMoney(
                                it?.invoiceItem?.patientServiceRegister
                                  ?.discount ||
                                it?.invoiceItem?.drugOrder?.discount ||
                                it?.invoiceItem?.treatmentPlanCard
                                  ?.discount ||
                                0
                              )}
                            </td>
                            <td>
                              {formatMoney(
                                it?.invoiceItem?.subAmountActuallyPaid || 0
                              )}
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={4}>Không có dữ liệu</td>
                    </tr>
                  )}
                </tbody>
              </table>
              <table className="summary-table">
                <tbody>
                  <tr>
                    <td className="label-print">Tổng số lượng :</td>
                    <td className="value-print">{totalValue?.totalQuantity}</td>
                  </tr>
                  <tr>
                    <td className="label-print">Tiền hàng :</td>
                    <td className="value-print" style={{ fontWeight: "bold" }}>
                      {formatMoney(totalValue?.totalPrice)}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-print">Tổng tiền (VNĐ):</td>
                    <td className="value-print" style={{ fontWeight: "bold" }}>
                      {formatMoney(totalValue?.totalAmount)}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-print">Đã thanh toán :</td>
                    <td className="value-print" style={{ fontWeight: "bold" }}>
                      {formatMoney(totalValue?.totalPaid)}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-print">Khách hàng trả :</td>
                    <td className="value-print" style={{ fontWeight: "bold" }}>
                      {formatMoney(totalValue?.totalCurrentPaid)}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-print">Còn nợ :</td>
                    <td className="value-print" style={{ fontWeight: "bold" }}>
                      {formatMoney(totalValue?.totalDebit)}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-print">Ghi chú :</td>
                    <td className="value-print">
                      {rowDataVoucher?.note || "Không có ghi chú"}
                    </td>
                  </tr>
                </tbody>
              </table>

              <div style={{ textAlign: "center", fontSize: "12px" }}>
                <span>Chữ ký khách hàng</span>
                <div style={{ height: "60px" }}></div>
              </div>

              <div style={{ textAlign: "center" }}>
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "10px",
                    textTransform: "uppercase",
                  }}
                >
                  <span>
                    Trung tâm Thẩm mỹ sẽ không hoàn lại tiền khi khách hàng tự ý
                    ngưng dịch vụ, sẽ chuyển sang lấy sản phẩm hoặc dịch vụ
                    khác.
                  </span>
                </div>
                <div className="mt-2">
                  <span style={{ fontSize: "12px" }}>Cảm ơn quý khách!</span>
                </div>
                <div>
                  <VoucherPrintDepartmentFooter
                    department={rowDataVoucher?.department}
                    style={{ marginTop: "12px", fontSize: "12px" }}
                  />
                  <br />
                  {/* <span style={{ color: "gray", fontWeight: "bold" }}>
                    1136000485
                  </span> */}
                  <QrSurveySection patient={rowDataVoucher?.patient} />
                </div>
              </div>
            </div>
          </div>
        </table>
      </header>
    </PrintCommon>
  );
};

export default memo(PrintFormRetailProductService);
